export default [
  {
    label: "PAN Card",
    value: "^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$"
  },
  {
    label: "Aadhar Card",
    value: "^\\d{4}\\s\\d{4}\\s\\d{4}$|^\\d{4}\\d{4}\\d{4}$"
  },
  {
    label: "4 Digit Year (1800-2100)",
    value: "(?:(?:18|19|20|21)[0-9]{2})"
  },
  {
    label: "Goods and Services Tax",
    value: "\\d{2}[A-Z]{5}\\d{4}[A-Z]{1}[A-Z\\d]{1}[Z]{1}[A-Z\\d]{1}"
  }
];
